import { apiDeleteWithCookie, apiPost } from './client';

export interface SessionResponse {
  /** ISO-8601 instant after which the server stops honoring the cookie. */
  expiresAt: string;
}

/**
 * Mints the `ailab_session` cookie (HttpOnly, set by the server). Static sub-project pages render in an
 * iframe, which can't send our bearer / dev header, so the server accepts this cookie on those routes.
 * A cookie the browser already holds is replaced, so periodic renewals keep one session per browser.
 */
export function createSession(): Promise<SessionResponse> {
  return apiPost<SessionResponse>('/sessions');
}

/**
 * Revokes the current `ailab_session` cookie server-side and expires it in the browser. Authenticated by
 * the cookie itself, so sign-out still revokes it after the bearer has expired. A 401 means the browser
 * holds no live session cookie, so there is nothing to revoke and it resolves too.
 */
export async function endSession(signal?: AbortSignal): Promise<void> {
  const response = await apiDeleteWithCookie('/sessions/current', signal);
  if (response.ok || response.status === 401) return;
  throw new Error(`could not revoke the session cookie: HTTP ${response.status}`);
}
